import React from 'react'

import Icon, { EIconId } from '../../../../components/icons'

import { EIconType } from '../../../../types/tickers'

const TickerIcon: React.FC<{ type: EIconType }> = (props) => {
  const className = 'w-20 mr-8 flex-shrink-0'
  return (
    <>
      {props.type === EIconType.CUSTOMER_SERVICE && <Icon id={EIconId.HEADPHONE} className={className} />}
      {props.type === EIconType.EXCHANGE_30 && <Icon id={EIconId.EXCHANGE30} className={className} />}
      {props.type === EIconType.EXCHANGE && <Icon id={EIconId.EXCHANGE} className={className} />}
      {props.type === EIconType.MEDAL && <Icon id={EIconId.MEDAL} className={className} />}
      {props.type === EIconType.TOP_DEAL && <Icon id={EIconId.TOP_DEAL} className={className} />}
    </>
  )
}

export default TickerIcon
